import { reactMount } from '@/lib/reactMount'
import { useEffect, useRef, useState } from 'react'
import { Button } from '@/components/Button'
import useSWRMutation from 'swr/mutation'
import { fetcher } from '@/lib/fetcher'
import { FormField } from '@/components/FormField'

export const findDealerWidget = ({ dataset, umbraco, version = 'default' }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'
  const [selectedProduct, setSelectedProduct] = useState('')

  const {
    trigger: triggerSearch,
    data: dealerBuyingOptionsResults,
    isMutating: isLoading
  } = useSWRMutation('/api/data/DealerBuyingOptions', fetcher)

  useEffect(() => {
    triggerSearch({ method: 'GET' })
  }, [triggerSearch])

  const productOptions = dealerBuyingOptionsResults?.data || []

  const handleProductChange = (e) => {
    setSelectedProduct(e.target.value)
  }

  const handleFindNow = () => {
    const selectedProductObj = productOptions.find(option => option.Name === selectedProduct)
    if (selectedProductObj) {
      window.location.href = `/find-dealer?product=${selectedProductObj.Value}`
    }
  }

  return (
    <div className='px-4 sm:px-6 lg:px-8' style={{ backgroundColor }}>
      <div className='_block-section max-w-[524px] mx-auto py-8'>
        <form className='relative overflow-hidden flex flex-col lg:flex-row lg:flex-wrap gap-3 px-6 py-8 lg:px-12 lg:py-16 rounded-2xl bg-primary-950'>
          <div className='absolute bg-yellow-rad w-full h-[600px] left-0 top-1/2 pointer-events-none' />
          <h2 className='relative z-10 text-2xl leading-7 font-extrabold text-white text-center lg:w-full mb-3'>I want to buy</h2>

          <div className='relative z-10 flex flex-col md:flex-row w-full gap-4'>
            <div className='grid grid-cols-1 grow'>
              <FormField
                type='select'
                label=''
                id='selectedProduct'
                name='selectedProduct'
                value={selectedProduct}
                onChange={handleProductChange}
                options={productOptions.map(option => option.Name)}
                placeholder='Select a product'
                disabled={isLoading}
                className='relative grow _lg-select'
              />
            </div>
            <Button
              size='lg'
              variant='primary'
              className='relative'
              onClick={handleFindNow}
              disabled={!selectedProduct}
            >
              Find Now
            </Button>
          </div>

        </form>
      </div>
    </div>
  )
}

reactMount('findDealerWidget', findDealerWidget)
